export default __webpack_public_path__ + "static/media/Helm of the Tormentor.1c40263b.jpg";